import { Rect } from "../../../platform/geom/Rect";
import { CardPile } from "./CardPile";

export const CardPileLayout = (object: CardPile) => {

    const base = new Rect(0, 0, object.width, object.height);

    // Card
    const cw = 140;
    const ch = 180;

    // Button
    const bw = 60;
    const bh = 30;

    const label = base.set({ height: 60 }).inflate(-10);

    const stack = new Rect((base.width - (cw + 20 + bw)) / 2, label.bottom + 10, cw, ch);

    const gap = (stack.height - (bh * 3)) / 4;

    const shuffle = new Rect(stack.right + 20, stack.top + gap, bw, bh);
    const drawOne = new Rect(stack.right + 20, shuffle.bottom + gap, bw, bh);
    const drawAll = new Rect(stack.right + 20, drawOne.bottom + gap, bw, bh);

    const count = stack.set({
        top: stack.bottom,
        height: 30,
    });

    return { base, label, stack, shuffle, drawOne, drawAll, count };
};

export type CardPileLayout = ReturnType<typeof CardPileLayout>;